import Waves from './waves';
export default Waves;
